<template>
  <div class="profile">
    <div class="row">
      <div class="change-box">
        <span class="name">Name</span>
        <div class="btns">
          <span v-if="!changeName" class="btn active" @click="changeInfo">Change</span>
          <span v-if="changeName" class="btn" @click="cancelChange">Cancel</span>
          <span v-if="changeName" class="btn active" @click="changeUserInfo">Save</span>
        </div>
      </div>
      <div class="value">
        <div v-if="changeName" class="input">
          <i-input v-model="changeUserName" placeholder="User Name" />
        </div>
        <span v-else>{{ userName }}</span>
      </div>
    </div>
    <div class="row">
      <div class="change-box">
        <p class="name">Email<span v-if="!verify" class="verify">Unverified</span></p>
        <div v-if="!verify" class="btn active" @click="verifyEmail">Verify</div>
      </div>
      <p v-if="!change || verify" class="value">{{ email }}</p>
      <div v-else class="verify-email">
        <p class="title">
          After verification, you can be the first to know about packages status and payment information by email
        </p>
        <div class="verify-box">
          <p class="desc">We sent a one-time verification code to your email. Please type the code below</p>
          <div class="email-code">
            <i-input v-model="code" class="verify-input" placeholder="Verification code" />
            <Button class="verify-btn" :loading="loading" @click="verifyEmailCode">Confirm</Button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="change-box">
        <span class="name">Password</span>
        <div class="btns">
          <span v-if="!changePasw" class="btn active" @click="changePaswInfo">Change</span>
          <span v-if="changePasw" class="btn" @click="cancelChange">Cancel</span>
          <span v-if="changePasw" autocomplete="off" class="btn active" @click="changePasswordInfo">Save</span>
        </div>
      </div>
      <div class="value">
        <div v-if="changePasw" class="input">
          <i-input
            v-show="curPasw"
            v-model="opasw"
            class="pasw"
            autocomplete="new-password"
            type="password"
            placeholder="Current password"
          />
          <i-input v-model="pasw" class="pasw" autocomplete="new-password" type="password" placeholder="New password" />
          <i-input
            v-model="cpasw"
            class="pasw"
            autocomplete="new-password"
            type="password"
            placeholder="Confirm new password"
          />
        </div>
        <p v-else>********</p>
      </div>
    </div>
    <!--
    <div class="row">
      <div class="change-box">
        <span class="name">Default Payment Method</span>
        <div v-if="cardNumber" class="btns">
          <span v-if="!changeCard" class="btn active" @click="changeCard = true">Remove</span>
          <span v-if="changeCard" class="btn" @click="removeCard">Confirm</span>
          <span v-if="changeCard" class="btn active" @click="changeCard = false">Cancel</span>
        </div>
        <div v-else class="btns">
          <span v-if="!changeCard" class="btn active" @click="changeCard = true">Add</span>
          <span v-if="changeCard" class="btn" @click="changeCard = false">Cancel</span>
          <span v-if="changeCard" class="btn active" @click="bindCard">Save</span>
        </div>
      </div>
      <div>
        <div v-if="cardNumber">
          <div class="card">
            <img src="../../assets/imgs/credit-card.png" class="card-icon" alt="" />
            <div>
              <p class="card-title">Credit Card</p>
              <p class="card-text">•••• {{ cardNumber }}</p>
            </div>
          </div>
        </div>
        <div v-else-if="!cardNumber && changeCard">
          <StripeBindCardPay ref="stripeBindCard" @change-loading="changeLoading" @bind-success="bindSuccess" />
        </div>
      </div>
    </div>
    -->
    <i-spin v-if="loading" fix>
      <i-icon type="ios-loading" size="40" class="spin-icon-load" />
    </i-spin>
  </div>
</template>

<script>
import { API } from '@/net/http';
import md5 from 'js-md5';
import Button from '../../components/button/Button';
// import StripeBindCard from '../../components/stripe/StripeBindCard';
// import StripeBindCardPay from '@/components/stripe/StripeBindCardPay.vue';
export default {
  components: {
    // StripeBindCardPay,
    Button,
  },
  data() {
    return {
      loading: true,
      userName: '',
      email: '',
      change: false,
      changeUserName: '',
      opasw: '',
      pasw: '',
      cpasw: '',
      verify: true,
      code: '',
      changeName: false,
      changePasw: false,
      curPasw: true,
      // changeCard: false,
      cardNumber: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.change = false;
      this.changeName = false;
      this.changePasw = false;
      this.$post(API.userUserInfo)
        .then(res => {
          if (res.success) {
            let { email, userName } = res.data;
            this.userName = userName;
            this.email = email;
            this.changeEmailVerify();
          } else {
            this.loading = false;
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
            this.$router.push({
              name: 'login',
              query: {
                backurl: this.$route.url,
              },
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
      this.fetchPaymentMethod();
    },
    fetchPaymentMethod() {
      this.$post(API.fetchPaymentMethod).then(res => {
        if (!res.success) return;
        const data = res.data;
        this.cardNumber = data.cardNumber;
      });
    },
    changeEmailVerify() {
      this.$post(API.authVerify)
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.verify = res.data.verifyEmail;
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changeInfo() {
      this.changeUserName = this.userName;
      this.changeName = true;
    },
    changePaswInfo() {
      this.loading = true;
      this.$post(API.userCurpwd)
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.changePasw = true;
            this.curPasw = res.data;
          } else {
            this.$Message.warning({
              content: res.message,
              duration: 3,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    cancelChange() {
      this.changePasw = false;
      this.changeName = false;
    },
    changeUserInfo() {
      this.loading = true;
      this.$post(API.userSaveName, {
        string: this.changeUserName,
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.userName = this.changeUserName;
            this.$store.commit('app/setAppConfig', {
              key: 'userName',
              val: this.changeUserName,
            });
            this.$Message.success({
              content: 'SUCCESS',
              duration: 3,
            });
            this.init();
          } else {
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changePasswordInfo() {
      if (
        (this.curPasw && this.opasw.trim().length === 0) ||
        this.pasw.trim().length === 0 ||
        this.pasw !== this.cpasw
      ) {
        this.$Message.error({
          content: 'password invalid',
        });
        return;
      }
      this.loading = true;
      this.$post(API.authSavePwd, {
        curPwd: this.curPasw ? md5(this.opasw) : '',
        newPwd: md5(this.pasw),
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.$Message.success({
              content: 'SUCCESS',
              duration: 3,
            });
            this.init();
          } else {
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    verifyEmail() {
      this.loading = true;
      this.$post(API.mailSendCode)
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.change = true;
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    verifyEmailCode() {
      if (this.loading) {
        return;
      }
      if (this.code.trim() === '') {
        this.$Message.error('code invalid.');
        return;
      }
      this.loading = true;
      this.$post(API.mailVerifyEmail, {
        verifyCode: this.code,
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.$Message.success({
              content: 'SUCCESS',
              duration: 5,
            });
            this.init();
          } else {
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /*
    removeCard() {
      this.$post(API.removeDefaultPaymentMethod).then(res => {
        if (!res.success) return;
        this.changeCard = false;
        this.cardNumber = '';
      });
    },
    bindCard() {
      this.$refs.stripeBindCard.confirmPayment(true);
    },
    bindSuccess() {
      this.$Message.success('Bind card success');
      this.changeCard = false;
      this.fetchPaymentMethod();
    },
     */
    changeLoading(loading) {
      this.loading = loading;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';
.profile {
  min-height: 614px;
  padding: 0 56px 56px 184px;
  position: relative;
  .row {
    margin-top: 56px;
    .change-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .name {
        .font-regular;
        font-size: 20px;
        font-weight: 400;
        color: @app-body-color;
        .verify {
          .font-light;
          display: inline-block;
          text-align: center;
          line-height: 26px;
          margin-left: 10px;
          width: 90px;
          height: 26px;
          border-radius: 13px;
          border: 1px solid @app-tag-color;
          font-size: 14px;
          font-weight: 300;
          color: @app-tag-color;
        }
      }
      .btn {
        .font-light;
        display: inline-block;
        width: 86px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 18px;
        font-size: 14px;
        font-weight: 300;
        color: @app-color;
        border: 1px solid @app-color;
        margin-left: 26px;
        &.active {
          color: #ffffff;
          background: @app-color;
        }
      }
    }
    .value {
      .font-regular;
      font-size: 26px;
      font-weight: 400;
      color: @app-black-color;
      padding-top: 22px;
      .input {
        width: 403px;
        .pasw {
          margin-bottom: 20px;
        }
      }
    }
    .verify-email {
      .title {
        .font-light;
        font-size: 14px;
        font-weight: 300;
        color: @app-black-color;
        padding: 17px 0 20px;
      }
      .verify-box {
        width: 591px;
        height: 124px;
        background: #eeeff0;
        opacity: 0.6;
        padding: 20px;
        .desc {
          .font-light;
          font-size: 14px;
          font-weight: 300;
          color: @app-black-color;
        }
        .email-code {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 20px;
          .verify-input {
            width: 278px;
          }
          .verify-btn {
            width: 109px;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
.card {
  .font-regular;
  background-color: #fbfbfb;
  display: flex;
  align-items: center;
  width: 300px;
  height: 66px;

  .card-icon {
    width: 40px;
    height: 40px;
    margin: 0 20px;
  }
  .card-title {
    color: #333333;
    font-size: 15px;
  }
  .card-text {
    color: #333333;
    font-size: 12px;
  }
}
</style>
